module.exports = __webpack_public_path__ + "img/sonarqube.635cdef0.svg";